import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth-service';
import { EnvironmentSettings } from '../shared/models/environmentsettings.model';
import { ConfigService } from '../shared/services/configService';
import { AuthenticationSettings } from '../shared/models/Authenticationsettings.model';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private _injector: Injector, private _configService: ConfigService, private router: Router) {

  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    //handle your auth error or rethrow
    if ((err.status === 401 || err.status == 403) && localStorage.getItem('app_token')) {
      this.router.navigate(["logOut"])

      return Observable.of(err.message);
    }
    return Observable.throw(err);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const index = req.url.indexOf('/api/');
    const baseUrl = req.url.substring(0, index + 1);
    const action = req.url.substr(index, req.url.length - index);
    const environmentSettings = new EnvironmentSettings();

    const authService = this._injector.get(AuthService);
    const config = authService.getAppConfig();
    if (config) {
      let token = localStorage.getItem('app_token') != null ? JSON.parse(localStorage.getItem('app_token')).token == null ? JSON.parse(localStorage.getItem('app_token')).access_token : JSON.parse(localStorage.getItem('app_token')).token : config.token;
      let userEmail = localStorage.getItem('userEmail') != null ? localStorage.getItem('userEmail').toString() : '';
      req = req.clone({
        setHeaders: {
          Authorization: 'Bearer ' + token,
          Email: userEmail
        }
      });
    }
    if (!(baseUrl === environmentSettings.apiEndPoint && action !== '/api/auth/signin' && !authService.appToken)) {
      return next.handle(req).pipe(catchError((err) => {

        if (err instanceof HttpErrorResponse) {

          if ((err.status === 401 || err.status == 403) && localStorage.getItem('app_token')) {
            this.router.navigate(["logOut"])
          }
        }
        return Observable.throw(err);
      }))
    }
  }
}




// WEBPACK FOOTER //
// ./src/opc/auth/auth-interceptor.ts